module.exports = __webpack_public_path__ + "static/media/capture.feb21956.jpg";